import { MenuItem } from 'primeng/api';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

/**
 * Segmentos de rota do módulo Órgão — fonte única (evita "magic strings" em
 * `*.routes.ts`, menus e `routerLink`). Renomear um caminho passa a ser um único lugar.
 */
export const ORGAO_ROUTES = {
    ROOT: 'orgao',
    DASHBOARD: '',
    DELEGACIA: 'delegacia',
    RELATORIOS: {
        ROOT: 'relatorios',
        FICHA_CADASTRAL: 'ficha-cadastral',
        COMPOSICAO: 'composicao'
    }
} as const;

/** Ações do menu lateral que dependem do componente (comandos), injetadas na factory. */
export interface OrgaoMenuActions {
    pesquisarPessoa: () => void;
}

/**
 * Menu lateral do módulo Órgão. Os `routerLink` derivam de `ORGAO_ROUTES` (sem
 * strings soltas) e os comandos vêm do componente via `actions`.
 */
export function createOrgaoMenu(actions: OrgaoMenuActions): MenuItem[] {
    return [
        {
            label: 'Home',
            expanded: true,
            items: [
                { label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: [ORGAO_ROUTES.ROOT] },
                { label: 'Pesquisar Pessoa', icon: 'pi pi-fw pi-search', command: actions.pesquisarPessoa },
                { label: 'Relatórios', icon: 'pi pi-fw pi-file-import', routerLink: [ORGAO_ROUTES.ROOT, ORGAO_ROUTES.RELATORIOS.ROOT], permission: PERMISSOES.orgaos.relatorios.escopo }
            ]
        }
    ];
}
